class Item {
    constructor({
      id = null,
      title = "",
      categoryAndSubCategory = null,
      imageUrl = "",
      street = "",
      city = "",
      startDate = "",
      startTime = "",
      isSponsored = false,
      isPromoted = false,
    } = {}) {
      this.id = id;
      this.title = title;
      this.categoryAndSubCategory = categoryAndSubCategory;
      this.imageUrl = imageUrl;
      this.street = street;
      this.city = city;
      this.startDate = startDate;
      this.startTime = startTime;
      this.isSponsored = isSponsored;
      this.isPromoted = isPromoted;
    }
  }

  export default class EventResponse {
    constructor() {
      this.totalCount = 0; // Initialize the totalCount to zero
      this.items = [];     // Initialize an empty array to hold the items
    }
  
    // Method to populate the class instance from an API response object
    fromResponse(response) {
      this.totalCount = response.totalCount || 0; // Set totalCount or default to 0
      this.items = response.items 
        ? response.items.map(item => new Item(item)) // Convert each item in the response to an Item instance
        : [];
    }
  
    // Convert the class instance to JSON format
    toJSON() {
      return {
        totalCount: this.totalCount,
        items: this.items.map(item => ({
          id: item.id,
          title: item.title,
          categoryAndSubCategory: item.categoryAndSubCategory,
          imageUrl: item.imageUrl,
          street: item.street,
          city: item.city,
          startDate: item.startDate,
          startTime: item.startTime,
          isSponsored: item.isSponsored,
          isPromoted: item.isPromoted
        }))
      };
    }

    canFetchMoreItems() {
      return this.items.length < this.totalCount;
    }
  }
